import React from "react";
import { secondaryTextColorOppositeShade } from "../../utils/constants";

export default function TaskFulfilled({ color = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.83 63.83">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <path
            fill={color}
            d="M46,21.79a2.47,2.47,0,0,1,0,3.52L29.29,42a2.49,2.49,0,0,1-3.52,0l-8-8a2.49,2.49,0,0,1,3.52-3.53l6.2,6.2,15-15A2.47,2.47,0,0,1,46,21.79ZM63.83,31.91A31.92,31.92,0,1,1,31.91,0,31.91,31.91,0,0,1,63.83,31.91Zm-5,0A26.93,26.93,0,1,0,31.91,58.84,26.91,26.91,0,0,0,58.84,31.91Z"
          />
        </g>
      </g>
    </svg>
  );
}
